<div class="card-header" style="padding-bottom: 0px">
  <div class="card-title">
    <h3 class="card-label">Focused View</h3>
  </div>
</div>
<mat-dialog-content>
  <div style="display: flex">
    <div class="example-full-width m-4">
      <mat-form-field class="mat-form-field-fluid" appearance="fill">
        <mat-label>Session Type</mat-label>

        <mat-select
          required
          [(ngModel)]="sessionType"
          (selectionChange)="onSessionTypeChanged()"
          [disabled]="isClosing"
          placeholder="Session Type"
          [formControl]="sessionTypeFormControl"
        >
          <mat-option *ngFor="let session of sessionTypeOptions" [value]="session.value">
            {{ session.label }}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="sessionTypeFormControl.hasError('required')">
          This field is required
        </mat-error>
      </mat-form-field>

      <div>
        <kt-general-autocomplete
          style="width: 100%"
          [appearance]="'fill'"
          [loadItemsFunction]="contactAutocompleteCall"
          [optionSearchFields]="contactSearchFields"
          [optionHeader]="stringUtils.getEntityHeader('CONTACT')"
          [optionFormatter]="stringUtils.getEntityFormatter.bind(stringUtils, 'CONTACT')"
          [valueFormatter]="stringUtils.displayName"
          [required]="true"
          [readOnly]="isClosing"
          [change]="onContactChange.bind(this)"
          [dataPath]="'data'"
          [placeholder]="'Search for contact...'"
          [control]="contactController"
          [label]="'Contact'"
          #contactAutocomplete
        ></kt-general-autocomplete>
      </div>

      <mat-form-field class="mat-form-field-fluid" appearance="fill">
        <mat-label>Filter Type</mat-label>

        <mat-select
          [(ngModel)]="filterType"
          (selectionChange)="onFilterTypeChanged()"
          [disabled]="isClosing"
          placeholder="Filter Type"
          [formControl]="filterTypeFormControl"
        >
          <ng-container *ngFor="let filter of filterTypeOptions">
            <mat-option *ngIf="isClosing || availableFilterTypes[filter.value]" [value]="filter">
              {{ filter.label }}
            </mat-option>
          </ng-container>
        </mat-select>
        <mat-error *ngIf="filterTypeFormControl.hasError('required')">
          This field is required
        </mat-error>
      </mat-form-field>
      <mat-form-field class="mat-form-field-fluid" appearance="fill">
        <mat-label>Selected Filter</mat-label>

        <mat-select
          [(value)]="selectedFilter"
          (selectionChange)="onSessionTypeChanged()"
          [disabled]="isClosing"
          placeholder="Selected Filter"
          multiple
        >
          <div class="select-all">
            <mat-checkbox (change)="selectAll()">Select All</mat-checkbox>
          </div>
          <ng-container *ngFor="let filter of selectedFilterOptions">
            <mat-option
              *ngIf="filterType && filter.entity_type === filterType.value"
              [value]="filter"
            >
              {{ stringUtils.displayName(filter) }}
            </mat-option>
          </ng-container>
        </mat-select>
      </mat-form-field>

      <mat-form-field class="mat-form-field-fluid" appearance="fill">
        <mat-label>Session Start</mat-label>
        <input matInput [(ngModel)]="startTime" [disabled]="true" />
      </mat-form-field>
    </div>
    <div *ngIf="isClosing" class="example-full-width m-4">
      <mat-form-field class="mat-form-field-fluid" appearance="fill">
        <mat-label>Status</mat-label>

        <mat-select
          required
          [(ngModel)]="status"
          (selectionChange)="onStatusChanged()"
          placeholder="Session Type"
          [formControl]="statusFormControl"
        >
          <mat-option *ngFor="let status of statusOptions" [value]="status.value">
            {{ status.label }}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="statusFormControl.hasError('required')">
          This field is required
        </mat-error>
      </mat-form-field>

      <mat-form-field class="mat-form-field-fluid" appearance="fill">
        <mat-label>Call Notes</mat-label>
        <textarea matInput [(ngModel)]="callNote" maxlength="499" [cols]="3"></textarea>
      </mat-form-field>

      <mat-form-field class="mat-form-field-fluid" appearance="fill">
        <mat-label>Completed Time</mat-label>
        <input matInput [(ngModel)]="endTime" [disabled]="true" />
      </mat-form-field>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end" style="padding: 18px 36px">
  <div style="width: 100%; display: flex; justify-content: flex-end">
    <div class="d-flex justify-content-between">
      <div class="mr-2"></div>
      <div>
        <button
          type="button"
          mat-dialog-close
          mat-raised-button
          cdkFocusInitial
          matTooltip="Cancel"
          [disabled]="data && data.preventCancel"
        >
          Cancel
        </button>
        <button
          type="submit"
          mat-raised-button
          color="primary"
          matTooltip="Create"
          style="margin-right: 5px"
          [disabled]="disableConfirmBtn"
          (click)="onStartClicked()"
        >
          {{ isClosing ? 'Complete' : 'Start' }}
        </button>
      </div>
    </div>
  </div>
</mat-dialog-actions>
